import { render } from "./FormRange.vue?vue&type=template&id=9ac0399a"
import script from "./FormRange.vue?vue&type=script&lang=js"
export * from "./FormRange.vue?vue&type=script&lang=js"
script.render = render

export default script